import { render, staticRenderFns } from "./ModalCriarPessoa.vue?vue&type=template&id=0d59869c"
import script from "./ModalCriarPessoa.vue?vue&type=script&lang=js"
export * from "./ModalCriarPessoa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports